/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from 'redux';
import { makeAsyncSelectors } from 'ui-lottery/src/utils/async_utils';
import passType, { selectors as passTypeSelectors } from './passType';
import passTypes from './passTypes';
import reservation, { selectors as reservationSelectors } from './reservation';
import reservations from './reservations';
import passSeries, { selectors as seriesSelectors } from './passSeries';
import { alerts, selectors as alertsSelectors } from './alerts';

const { isLoading, isLoaded, getErrors, hasErrors } = makeAsyncSelectors('pass');

const reducers = combineReducers({
    passType,
    passTypes,
    reservation,
    reservations,
    passSeries,
    alerts,
});

export default reducers;

// All of our Redux selectors
export {
    isLoading,
    isLoaded,
    hasErrors,
    getErrors,
    passTypeSelectors,
    reservationSelectors,
    seriesSelectors,
    alertsSelectors,
};
